import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const GUEST_KEY = "cosomic_guest_id";

/** Read the persisted guest id (or null). */
export function getGuestId() {
  try { return localStorage.getItem(GUEST_KEY) || null; } catch (_) { return null; }
}

/** Save the guest id handed back by the server. */
export function setGuestId(id) {
  if (!id) return;
  try { localStorage.setItem(GUEST_KEY, id); } catch (_) { /* noop */ }
}

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

// Attach the guest id to every outgoing request so the backend can reconcile
// an anonymous visitor's 3-free-actions quota across page reloads / tabs.
api.interceptors.request.use((config) => {
  const gid = getGuestId();
  if (gid) {
    config.headers = { ...(config.headers || {}), "X-Guest-Id": gid };
  }
  return config;
});

// Pick up the server-assigned guest id (first request mints one) and persist it.
function _extractGuestId(headers) {
  if (!headers) return null;
  if (typeof headers.get === "function") {
    return headers.get("x-guest-id") || headers.get("X-Guest-Id") || null;
  }
  return headers["x-guest-id"] || headers["X-Guest-Id"] || null;
}

api.interceptors.response.use(
  (res) => {
    const gid = _extractGuestId(res?.headers);
    if (gid && gid !== getGuestId()) setGuestId(gid);
    return res;
  },
  (err) => {
    const gid = _extractGuestId(err?.response?.headers);
    if (gid && gid !== getGuestId()) setGuestId(gid);
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
